module.exports = __webpack_public_path__ + "static/media/slider-banner3.ec756472.jpg";